import React, { useState } from 'react';
import './HostingWordPress.css';

const HostingWordPress = () => {
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  const plans = [
    {
      tier: 'وب‌سایت شخصی',
      price: '۱۸۰',
      unit: 'هزار تومان / ماه',
      disk: '۵ گیگابایت NVMe',
      visits: '۱۰,۰۰۰ بازدید',
      features: ['LiteSpeed Cache', '۱ دامنه', 'نصب WP یک‌کلیک', 'SSL رایگان', 'پشتیبانی ۲۴/۷'],
      popular: false,
    },
    {
      tier: 'فروشگاه آنلاین',
      price: '۳۵۰',
      unit: 'هزار تومان / ماه',
      disk: '۲۰ گیگابایت NVMe',
      visits: '۵۰,۰۰۰ بازدید',
      features: ['LiteSpeed + Redis', '۳ دامنه', 'بهینه WooCommerce', 'SSL رایگان', 'بکاپ روزانه', 'پشتیبانی ۲۴/۷'],
      popular: true,
    },
    {
      tier: 'آژانس / چندسایته',
      price: '۶۵۰',
      unit: 'هزار تومان / ماه',
      disk: '۵۰ گیگابایت NVMe',
      visits: '۲۰۰,۰۰۰ بازدید',
      features: ['LiteSpeed + Redis + CDN', 'نامحدود دامنه', 'SSL Wildcard', 'بکاپ روزانه', 'IP اختصاصی', 'اولویت پشتیبانی'],
      popular: false,
    },
  ];

  const features = [
    {
      icon: '⚡',
      title: 'بهینه‌سازی ویژه وردپرس با LiteSpeed',
      desc: 'استفاده از وب‌سرور LiteSpeed با کش پیشرفته و بهینه‌سازی‌های اختصاصی برای وردپرس. سرعت بارگذاری وب‌سایت شما تا ۱۰ برابر افزایش می‌یابد و تجربه کاربری فوق‌العاده‌ای را برای بازدیدکنندگان فراهم می‌کند.',
    },
    {
      icon: '🛒',
      title: 'بهینه‌سازی فروشگاه‌های ووکامرس',
      desc: 'هاست وردپرس افرسل با بهینه‌سازی‌های ویژه برای فروشگاه‌های ووکامرس، سرعت بالای پردازش سفارشات، کش محصولات و بهبود تجربه خرید کاربران را فراهم می‌کند.',
    },
    {
      icon: '🔒',
      title: 'امنیت پیشرفته وردپرس',
      desc: 'محافظت کامل از وب‌سایت وردپرسی شما در برابر حملات سایبری، هک و بدافزارها. به‌روزرسانی خودکار پلاگین‌ها و سیستم امنیتی پیشرفته.',
    },
    {
      icon: '📝',
      title: 'نصب یک‌کلیک وردپرس',
      desc: 'نصب و راه‌اندازی وردپرس با یک کلیک. انتخاب از بین هزاران قالب و پلاگین و شروع سریع وب‌سایت شما بدون نیاز به دانش فنی.',
    },
  ];

  const faqs = [
    {
      q: 'هاست وردپرس چه تفاوتی با هاست معمولی دارد و چرا باید از آن استفاده کنم؟',
      a: 'هاست وردپرس به طور ویژه برای وب‌سایت‌های وردپرسی بهینه‌سازی شده است. این نوع هاست شامل کش پیشرفته (LiteSpeed Cache)، CDN، بهینه‌سازی پایگاه داده، امنیت ویژه و نصب یک‌کلیک وردپرس می‌شود. سرعت بارگذاری صفحات وردپرسی در هاست تخصصی به طور قابل توجهی بالاتر است و تجربه کاربری بهتری را برای بازدیدکنندگان شما فراهم می‌کند. همچنین، هاست وردپرس با بهینه‌سازی‌های ووکامرس، برای فروشگاه‌های آنلاین گزینه‌ای ایده‌آل است.',
    },
    {
      q: 'آیا هاست وردپرس از ووکامرس پشتیبانی می‌کند؟',
      a: 'بله، هاست وردپرس افرسل با بهینه‌سازی‌های ویژه برای ووکامرس، سرعت بالای پردازش سفارشات، کش محصولات و بهبود تجربه خرید کاربران را فراهم می‌کند. شما می‌توانید فروشگاه آنلاین خود را با ووکامرس روی هاست وردپرس راه‌اندازی کنید و از سرعت بالا و پایداری عالی بهره‌مند شوید.',
    },
  ];

  return (
    <>
      <div className="seo-header">
        <h1>هاست وردپرس | خرید هاست وردپرس با بهترین قیمت و سرعت | افرسل</h1>
        <p>خرید هاست وردپرس با سرورهای NVMe، LiteSpeed Cache، بهینه‌سازی ووکامرس و پشتیبانی ۲۴ ساعته. هاست وردپرس مناسب برای وبلاگ‌ها، فروشگاه‌های آنلاین و وب‌سایت‌های شرکتی.</p>
        <meta name="description" content="خرید هاست وردپرس با بهترین قیمت از افرسل. هاست وردپرس با NVMe، LiteSpeed Cache، بهینه‌سازی ووکامرس، SSL رایگان و پشتیبانی ۲۴/۷." />
      </div>

      <section className="hosting-wordpress-hero">
        <div className="hosting-wordpress-hero-bg"></div>
        <div className="wrap">
          <div className="hosting-wordpress-hero-content">
            <div className="hosting-wordpress-badge">
              <span className="pulse-dot"></span>
              📝 هاست وردپرس
            </div>
            <h1 className="hosting-wordpress-hero-title">
              هاست <em>وردپرس</em>
            </h1>
            <p className="hosting-wordpress-hero-desc">
              هاست تخصصی وردپرس با سرورهای NVMe، LiteSpeed Cache و بهینه‌سازی‌های اختصاصی.
              مناسب برای وبلاگ‌ها، فروشگاه‌های آنلاین و وب‌سایت‌های شرکتی با سرعت بالا و پایداری عالی.
            </p>
            <div className="hosting-wordpress-hero-stats">
              <div className="stat-item">
                <span className="stat-number">۳</span>
                <span className="stat-label">پلن مختلف</span>
              </div>
              <div className="stat-item">
                <span className="stat-number">NVMe</span>
                <span className="stat-label">دیسک فوق‌سریع</span>
              </div>
              <div className="stat-item">
                <span className="stat-number">LiteSpeed</span>
                <span className="stat-label">کش پیشرفته</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="hosting-wordpress-plans">
        <div className="wrap">
          <div className="sec-header">
            <span className="sec-tag">پلن‌های هاست وردپرس</span>
            <h2 className="sec-h">پلن <em>مناسب</em> وب‌سایت وردپرسی خود را انتخاب کنید</h2>
            <p className="sec-p">پلن‌های متنوع هاست وردپرس با قیمت‌های رقابتی و منابع کافی برای هر نوع وب‌سایت وردپرسی.</p>
          </div>
          <div className="hosting-wordpress-plans-grid">
            {plans.map((plan, i) => (
              <div key={i} className={`hosting-wordpress-plan ${plan.popular ? 'popular' : ''}`}>
                {plan.popular && <span className="hosting-wordpress-popular-badge">پرفروش‌ترین</span>}
                <div className="hosting-wordpress-plan-tier">{plan.tier}</div>
                <div className="hosting-wordpress-plan-price">
                  <span className="hosting-wordpress-plan-num">{plan.price}</span>
                  <span className="hosting-wordpress-plan-unit">{plan.unit}</span>
                </div>
                <div className="hosting-wordpress-plan-specs">
                  <div><span>💾</span> {plan.disk}</div>
                  <div><span>👁️</span> {plan.visits}</div>
                </div>
                <ul className="hosting-wordpress-plan-features">
                  {plan.features.map((feat, j) => (
                    <li key={j}><span>✓</span> {feat}</li>
                  ))}
                </ul>
                <button className="hosting-wordpress-order-btn" onClick={() => scrollTo('contact')}>سفارش دهید</button>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="hosting-wordpress-features">
        <div className="wrap">
          <div className="sec-header">
            <span className="sec-tag">مزایای هاست وردپرس</span>
            <h2 className="sec-h">چرا <em>هاست وردپرس</em> با افرسل؟</h2>
            <p className="sec-p">هاست وردپرس با بهترین امکانات و خدمات برای وب‌سایت‌های وردپرسی.</p>
          </div>
          <div className="hosting-wordpress-features-grid">
            {features.map((feature, i) => (
              <div key={i} className="hosting-wordpress-feature-card">
                <span className="hosting-wordpress-feature-icon">{feature.icon}</span>
                <h3 className="hosting-wordpress-feature-title">{feature.title}</h3>
                <p className="hosting-wordpress-feature-desc">{feature.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="hosting-wordpress-faq">
        <div className="wrap">
          <div className="sec-header">
            <span className="sec-tag">سوالات متداول</span>
            <h2 className="sec-h">پاسخ به <em>سوالات</em> شما</h2>
          </div>
          <div className="hosting-wordpress-faq-grid">
            {faqs.map((faq, i) => (
              <div key={i} className="hosting-wordpress-faq-item">
                <div className="hosting-wordpress-faq-q">{faq.q}</div>
                <div className="hosting-wordpress-faq-a">{faq.a}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="hosting-wordpress-cta">
        <div className="wrap">
          <div className="cta-box">
            <h2 className="cta-title">
              هاست <em>وردپرس</em> را همین حالا خریداری کنید
            </h2>
            <p className="cta-desc">
              با خرید هاست وردپرس، از سرعت بالا، پایداری عالی و پشتیبانی ۲۴ ساعته بهره‌مند شوید.
            </p>
            <div className="cta-btns">
              <button className="btn-lg primary" onClick={() => scrollTo('contact')}>خرید هاست</button>
              <button className="btn-lg ghost" onClick={() => scrollTo('contact')}>مشاوره رایگان</button>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default HostingWordPress;
